import React from "react";
import '../../sass/components/flexibleModules/_components.metricSectionComponent.scss';

const MetricSectionComponent = ({ data }) => {
    return (
        <div className={`cp-metricSectionComponent ${data.layoutSelection ? data.layoutSelection : ""}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-metricSectionComponent__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.metricsSectionSubHeader &&
                    <h4 dangerouslySetInnerHTML={{ __html: data.metricsSectionSubHeader }} />
                }
                {data.metricsSectionHeader &&
                    <h3>{data.metricsSectionHeader}</h3>
                }
                {data.metricsSectionHeaderLogo &&
                    <img loading="lazy" src={data.metricsSectionHeaderLogo.sourceUrl} alt={data.metricsSectionHeaderLogo.altText} />
                }
                {data.metricsSectionContent &&
                    <div className="l-content" dangerouslySetInnerHTML={{ __html: data.metricsSectionContent }} />
                }
                {data.metricsSectionRepeaterMetrics &&
                    <div className={`cp-metricSectionComponent__metrics l--flex l-lengthCheck${data.metricsSectionRepeaterMetrics.length}`}>
                        {data.metricsSectionRepeaterMetrics.map((metric, index) => (
                            <div key={index} className="cp-metricSectionComponent__metrics-section">
                                {metric.icon &&
                                    <img loading="lazy" src={metric.icon.sourceUrl} alt={metric.icon.altText} />
                                }
                                {metric.unit &&
                                    <h4>{metric.unit}</h4>
                                }
                                {metric.text &&
                                    <span>{metric.text}</span>
                                }
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
}

export default MetricSectionComponent;